module.exports = __webpack_public_path__ + "ai.no1.6636c973.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ai.no1.jpg
// module id = wcE4
// module chunks = 0